import type { ChainRegion } from './BoardRenderer.js';
import type { ChainLayout } from './geometry.js';
import type { Rect } from './Viewport.js';

/**
 * Rect framing what's currently on the table. For a non-empty chain we use
 * the layout's computed bounding box; for the empty chain we frame the
 * center of the chain region (so the lead drop-zone is centered after a
 * fit-to-view reset).
 */
export function computeChainBounds(layout: ChainLayout, region: ChainRegion): Rect {
  if (layout.tiles.length === 0) {
    const cx = region.x + region.width / 2;
    const cy = region.y + region.height / 2;
    const half = Math.min(region.width, region.height) * 0.25;
    return { minX: cx - half, minY: cy - half, maxX: cx + half, maxY: cy + half };
  }
  return {
    minX: layout.bounds.minX,
    minY: layout.bounds.minY,
    maxX: layout.bounds.maxX,
    maxY: layout.bounds.maxY,
  };
}

/** Convert a ChainRegion (canvas px) to a Rect for Viewport.computeFit. */
export function regionToRect(region: ChainRegion): Rect {
  return {
    minX: region.x,
    minY: region.y,
    maxX: region.x + region.width,
    maxY: region.y + region.height,
  };
}
